export default __webpack_public_path__ + "static/media/logo_texto.eba890eb.png";